import Vue from 'vue'
import App from './App'
import router from './router'
import VConsole from 'vconsole'
import Log from 'capture-request-log'
import config from '@/config/config.js'
import VueCookie from 'vue-cookie'
import VueClipboards from 'vue-clipboard2'
import { adminModule } from '@/components'
import { commonModule } from '@/components/common'
import store from './store'
import { postRequest } from '@/config/network'
import api from '@/api'
import { setIdentityVerificationLogReporter } from '@/api/identity-verification'
import { handleInitVideoRecord, setVideoRecordUid } from '@/config/video-record'
import { setTempVideoRecordUid } from '@/config/temp-video-record'
import {
  captureIdentityVerificationEntry,
  readIdentityVerificationEntry,
  resolveIdentityVerificationLogUid
} from '@/config/identity-verification-entry'
// import { apiPositionProblem } from '@/api/system/home'
// import compareGitInfo from '@/config/compareGitInfo'

// 自定义的全局方法
import {
  allHostList,
  getBrowser,
  getUrlPara,
  getOsFrom,
  format,
  getPhoneType,
  Decrypt,
  Encrypt,
  log,
  Debounce,
  openOrdownload,
  proxyClickDom,
  // isLessVersion,
  getLocalData,
  hostInfo,
  GoH5Home
} from '@/config/utils'
import GetUserInfo from '@/config/getUserInfo'
import { Base64 } from 'js-base64'
import {
  Empty,
  Popover,
  Button,
  Swipe,
  SwipeItem,
  Icon,
  ActionSheet,
  Checkbox,
  CheckboxGroup,
  PasswordInput,
  NumberKeyboard,
  Loading,
  Cell,
  CellGroup,
  Uploader,
  Radio,
  Switch,
  Toast,
  Dialog,
  PullRefresh,
  List,
  Tab,
  Tabs,
  Popup,
  Area,
  Picker,
  AddressEdit,
  AddressList,
  Field,
  Tabbar,
  TabbarItem,
  NoticeBar,
  DatetimePicker,
  TreeSelect,
  RadioGroup,
  Collapse,
  CollapseItem,
  Progress,
  SwipeCell,
  Overlay,
  Step,
  Steps,
  Image as VanImage,
  Circle,
  Divider,
  Form
} from 'vant'
import 'vant/lib/icon/local.css'

import VueAnimateNumber from 'vue-animate-number'
import installSvgs from 'lz-svgs'
import { noChoose, choose } from 'lz-svgs/svgs'
installSvgs([noChoose, choose])
Vue.use(Empty)
Vue.use(Popover)
Vue.use(VueAnimateNumber)
Vue.use(Form)
Vue.use(VueCookie)
Vue.use(Button)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Icon)
Vue.use(ActionSheet)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(Loading)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Uploader)
Vue.use(Radio)
Vue.use(Switch)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Tab).use(Tabs)
Vue.use(Tabbar).use(TabbarItem)
Vue.use(Popup)
Vue.use(Area)
Vue.use(Picker)
Vue.use(Dialog)
Vue.use(AddressEdit)
Vue.use(AddressList)
Vue.use(Field)
Vue.use(NoticeBar)
Vue.use(DatetimePicker)
Vue.use(TreeSelect)
Vue.use(RadioGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Progress)
Vue.use(SwipeCell)
Vue.use(Overlay)
Vue.use(Step)
Vue.use(Steps)
Vue.use(VanImage)
Vue.use(Circle)
Vue.use(Divider)
Vue.use(adminModule)
Vue.use(commonModule)
Vue.use(VueClipboards) // 复制工具
Vue.prototype.$toast = Toast // 轻提示
Vue.prototype.$dialog = Dialog // 弹出框
Vue.prototype.$getBrowser = getBrowser // 获取浏览器是否为微信
Vue.prototype.$getUrlPara = getUrlPara // 获取链接后面的参数
Vue.prototype.$getOsFrom = getOsFrom // 判断机型
Vue.prototype.$format = format // 格式化时间戳
Vue.prototype.$openOrdownload = openOrdownload // // 已注册打开APP
Vue.prototype.$proxyClickDom = proxyClickDom // 事件代理
Vue.prototype.$api = api // 暴露全局api
Vue.prototype.$agreeProtocol = (protocolIds, sceneCode) => api.main.apiAgreeProtocol.post({ protocolIds, sceneCode, isAgree: 1 })
Vue.prototype.$base64 = Base64
Vue.prototype.$decrypt = Decrypt
Vue.prototype.$encrypt = Encrypt
Vue.prototype.$Debounce = Debounce
// Vue.prototype.$isLessVersion = isLessVersion
Vue.prototype.$GoH5Home = GoH5Home
Vue.prototype.$hostInfo = hostInfo
Vue.config.productionTip = false // 来关闭生产模式下给出的提示

// HTML 壳已优先净化；这里再兜底处理开发环境和未更新壳页面，且必须早于 vConsole、用户初始化及日志 SDK。
const capturedIdentityVerificationEntry = captureIdentityVerificationEntry({
  location: window.location,
  history: window.history,
  sessionStorage: window.sessionStorage
})
const identityVerificationEntry = capturedIdentityVerificationEntry || readIdentityVerificationEntry(
  window.sessionStorage,
  window.location.pathname
)
const identityVerificationLogUid = resolveIdentityVerificationLogUid(
  window.sessionStorage,
  identityVerificationEntry && identityVerificationEntry.verificationCode
)

// 展示vConsole
const allHost = allHostList()
const testHostList = allHost.testHostList.concat(allHost.preHostList)
// 测试环境的 vConsole 会采集 XHR 请求体，匿名核身页必须禁用以免短码进入调试日志。
const isAnonymousIdentityVerificationPage = window.location.pathname.includes('/identity-verification')
if (testHostList.includes(window.location.host) && !isAnonymousIdentityVerificationPage) {
  const vConsole = new VConsole()
  Vue.use({
    vConsole
  })
}

const userInfo = GetUserInfo.getInstance()
store.commit('SET_USER_INFO', getLocalData('userInfo') || {})

const mobile = userInfo.mobile
const logMobile = userInfo.logMobile
const LOG_UID_TIMEOUT = 5000

// UID 接口异常时按超时降级为空，避免日志上报长期阻塞或影响业务页面。
const getLogUid = () => {
  if (isAnonymousIdentityVerificationPage && identityVerificationLogUid) {
    return Promise.resolve(identityVerificationLogUid)
  }
  if (!logMobile) return Promise.resolve('')
  return new Promise(resolve => {
    let isFinished = false
    const finish = (uid = '') => {
      if (isFinished) return
      isFinished = true
      clearTimeout(timeoutTimer)
      resolve(uid)
    }
    const timeoutTimer = setTimeout(finish, LOG_UID_TIMEOUT)
    api.main.getPhoneUid.post({}).then(res => {
      const uid = res && res.code === 1000 && res.data ? res.data.uid : ''
      finish(uid)
    }).catch(() => finish())
  })
}
const logUidPromise = getLogUid()
logUidPromise.then(uid => {
  const fixedUid = uid || ''
  setVideoRecordUid(fixedUid)
  setTempVideoRecordUid(fixedUid)
  Vue.prototype.$logUid = fixedUid
})
Vue.prototype.$mobile = mobile
Vue.prototype.$setMobile = (mobile) => {
  Vue.prototype.$mobile = mobile
}
if (logMobile) {
  const initVideoRecordError = handleInitVideoRecord(logMobile, userInfo.hasReturnData)
  const positionProblemParams = {
    pageName: location.pathname,
    channelCode: userInfo.lzCode,
    opt: 'h5_onLoad',
    devType: getPhoneType(), // 机型
    osVersion: getOsFrom() === 'ios' ? 'h5_ios' : 'h5_and', // 操作系统
    remark: ''
  }
  if (userInfo.appInfo) {
    Object.assign(positionProblemParams, { appVersion: userInfo.appInfo.appVersion })
  } else {
    Object.assign(positionProblemParams, { appVersion: localStorage.getItem('envData') && JSON.parse(Base64.decode(localStorage.getItem('envData'))).appVersion })
  }
  positionProblemParams.remark = JSON.stringify({ cacheLzCode: getLocalData('lzCode'), initVideoRecordError })
  // apiPositionProblem(positionProblemParams)

  // compareGitInfo('/unicom/static/gitInfo.json?t=' + Date.now(), '#div-git-info').then(data => {
  //   positionProblemParams.remark.isNewGitInfo = true
  //   positionProblemParams.remark.commitId = data.commitId
  //   positionProblemParams.remark = JSON.stringify(positionProblemParams.remark)
  //   apiPositionProblem(positionProblemParams)
  // }).catch(e => {
  //   try {
  //     const data = JSON.parse(e.message)
  //     if (data.msg) {
  //       positionProblemParams.remark.isNewGitInfo = false
  //       positionProblemParams.remark.gitInfo = data
  //       positionProblemParams.remark = JSON.stringify(positionProblemParams.remark)
  //       apiPositionProblem(positionProblemParams)
  //       if (['reload', 'hasReload'].includes(data.type)) {
  //         const divGitInfo = document.querySelector('#div-git-info')
  //         if (divGitInfo) {
  //           const timer = setTimeout(() => {
  //             clearTimeout(timer)
  //             apiPositionProblem({ ...positionProblemParams, remark: JSON.stringify({ gitInfo: divGitInfo.dataset.gitInfo, type: data.type }) })
  //           }, 1000)
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error('gitInfo.json error:', error)
  //   }
  // })
}

document.body.addEventListener('click', function (e) {
  window.curElement = e.target
})

const LOG = new Log({
  window,
  Vue,
  filterHttpUrl: config.filterHttpUrl,
  interceptDomain: config.interceptDomain,
  sendError (obj = {}) {
    // 普通日志等待 UID 获取完成后再上报，保证日志系统可以按 UID 精确检索。
    logUidPromise.then(uid => {
      Object.assign(obj, {
        mobile: logMobile,
        uid,
        logStartTime: getLocalData('log-start-time'),
        systemCode: 'unicom',
        systemCodeName: '联通沃支付',
        deviceType: getPhoneType(),
        projectCode: 'LIANT_YIJIE',
        projectCodeName: '联通易借'
      })
      postRequest(config.bllogAddUrl, obj).then(res => {})
    })
  }
})

/** 核身页复用原日志入口，仅允许固定的脱敏字段进入独立日志类型。 */
const reportIdentityVerificationLog = (title, details = {}) => {
  const allowedKeys = [
    'stage', 'method', 'path', 'httpStatus', 'errorCode', 'duration',
    'status', 'previousStatus', 'videoSize'
  ]
  const safeDetails = allowedKeys.reduce((result, key) => {
    if (details[key] !== undefined && details[key] !== '') result[key] = details[key]
    return result
  }, {})
  LOG.needIntercept && LOG.config.sendError({
    title,
    msg: JSON.stringify(safeDetails),
    url: window.location.pathname,
    type: 'identityVerification'
  })
}
setIdentityVerificationLogReporter(reportIdentityVerificationLog)
Vue.prototype.$identityVerificationLog = reportIdentityVerificationLog

// 捕获资源加载失败（图片、脚本、iframe等），error 事件不冒泡，需在捕获阶段监听
window.addEventListener('error', function (event) {
  var target = event.target || event.srcElement
  // 只处理资源加载错误，排除 JS 运行时错误（运行时错误由 window.onerror 处理）
  if (target === window) return
  var tagName = (target.tagName || '').toLowerCase()
  var resourceUrl = target.src || target.href || ''
  if (resourceUrl) {
    LOG.needIntercept && LOG.config.sendError({
      title: '资源加载失败: ' + tagName,
      msg: JSON.stringify({ tag: tagName, url: resourceUrl }),
      url: window.location.href,
      type: 'resource'
    })
  }
}, true)

window.onerror = function (msg, url, line, col, error) {
  // 跨域脚本错误，浏览器安全策略隐藏了详情，跳过上报
  if (msg === 'Script error.' && !url && line === 0) {
    return true
  }
  let ele = ''
  if (window.curElement !== '&lt;body&gt;&lt;/body&gt;') {
    let { tagName, textContent } = window.curElement
    tagName = tagName.toLowerCase()
    ele = window.curElement.getAttributeNames().reduce((data, name) => {
      return `${data} ${name}=${window.curElement.getAttribute(name)}`
    }, `&lt;${tagName}`)
    ele += `&gt;${textContent}&lt;/${tagName}&gt;`
  }
  if (error && error.stack) {
    LOG.needIntercept && LOG.config.sendError({
      title: `${msg}"${ele}"`,
      msg: JSON.stringify(error.stack),
      url: window.location.href,
      type: 'js'
    })
  } else if (typeof msg === 'string') {
    LOG.needIntercept && LOG.config.sendError({
      title: `${msg}"${ele}"`,
      msg: JSON.stringify(msg),
      url: window.location.href,
      type: 'js'
    })
  }
}

window.log = log
log('联合登录url参数：', userInfo.urlSearch)

// 生成vue的根实例;创建每个组件都会生成一个vue的实列，并且会用到根实例上面的所有属性
const vm = new Vue({
  el: '#app', // 决定了对象装载的位置 el: '#app'绑定的是index.html中的id="app"的元素
  router,
  store,
  components: {
    App
  }, // 注册成组件
  template: '<App/>' // 声明模版
})

Vue.use({
  vm,
  LOG
})

window.vm = vm
